// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import './helpers/arrayPolyfill'
require('es6-promise').polyfill()

Vue.config.productionTip = false
const divs = document.querySelectorAll('.qualifio-chart')

for (let index = 0; index < divs.length; index++) {
  const dataAttributs = divs[index].dataset
  /* eslint-disable no-new */
  new Vue({
    el: divs[index],
    components: {App},
    data () {
      return {
        dataAttributs
      }
    },
    template: '<App :dataAttributs="dataAttributs" />'
  })
}



// WEBPACK FOOTER //
// ./src/main.js